import AssetsRouteRoot from '../asset/config/routes';
import SupervisionRouteRoot from '../supervision/config/routes';
import EngineeringRouteRoot from '../engineering/config/routes';
import AssetInformationRouteRoot from '../assetInformation/config/routes';

const Installation = () => import(/* webpackChunkName: "installation" */ '../Installation');

export default {
  path: '/instalacao/:installationId/',
  component: Installation,
  redirect: {
    name: 'monitoring',
  },
  children: [
    AssetsRouteRoot,
    SupervisionRouteRoot,
    EngineeringRouteRoot,
    AssetInformationRouteRoot,
  ],
};
